"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../../Button/Button");
var _PaymentError = require("../../PaymentError/PaymentError");
var _PaymentManualModule = _interopRequireDefault(require("../PaymentManual.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var _default = function _default(_ref) {
  var platform = _ref.platform,
    actionType = _ref.actionType,
    error = _ref.error,
    callback = _ref.callback;
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    callback(_objectSpread(_objectSpread({}, actionType === 'withdraw' && {
      iban: event.target.iban.value
    }), {}, {
      amount: event.target.amount.value
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    as: _reactBootstrap.Form,
    noValidate: true,
    autoComplete: 'off',
    onSubmit: handleSubmit
  }, actionType === 'withdraw' && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : 5
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentManualModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(platform === 'mob' ? _reactBootstrap.FloatingLabel : _react.default.Fragment, _objectSpread({}, platform === 'mob' && {
    label: 'ანგარიშის ნომერი',
    style: {
      width: '100%',
      color: '#868895'
      /*color: !error.iban ? '#868895' : 'var(--bs-danger)',*/
    },

    className: _PaymentManualModule.default.floatingLabel
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    name: 'iban',
    placeholder: 'ანგარიშის ნომერი',
    isInvalid: !!error.iban
  })), platform === 'mob' && !!error.iban && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.iban)), platform === 'web' && /*#__PURE__*/_react.default.createElement(_PaymentError.PaymentError, {
    show: !!error.iban,
    message: error.iban
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : actionType === 'withdraw' ? 4 : 7
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentManualModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(platform === 'mob' ? _reactBootstrap.FloatingLabel : _react.default.Fragment, _objectSpread({}, platform === 'mob' && {
    label: 'თანხა',
    style: {
      width: '100%',
      color: '#868895'
      /*color: !error.amount ? '#868895' : 'var(--bs-danger)',*/
    },

    className: _PaymentManualModule.default.floatingLabel
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    name: 'amount',
    type: 'number',
    placeholder: 'თანხა',
    isInvalid: !!error.amount
  })), platform === 'mob' && !!error.amount && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.amount)), platform === 'web' && /*#__PURE__*/_react.default.createElement(_PaymentError.PaymentError, {
    show: !!error.amount,
    message: error.amount
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: platform === 'mob' ? 12 : actionType === 'withdraw' ? 3 : 5
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: actionType === 'deposit' ? 'success' : 'secondary',
    type: 'submit',
    style: actionType === 'withdraw' && {
      backgroundColor: '#435FA0',
      borderColor: '#435FA0'
    }
  }, actionType === 'deposit' ? 'შევსება' : 'გატანა')));
};
exports.default = _default;